var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndoButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53492 4.05H10.5C13.5376 4.05 16 6.51243 16 9.55C16 12.5876 13.5376 15.05 10.5 15.05H6.99731C6.44503 15.05 5.99731 14.6023 5.99731 14.05C5.99731 13.4977 6.44503 13.05 6.99731 13.05H10.5C12.433 13.05 14 11.483 14 9.55C14 7.617 12.433 6.05 10.5 6.05H3.53492L5.79246 8.30754C6.20251 8.71759 6.20251 9.38241 5.79246 9.79246C5.38241 10.2025 4.71759 10.2025 4.30754 9.79246L0.307538 5.79246C-0.102513 5.38241 -0.102513 4.71759 0.307538 4.30754L4.30754 0.307538C4.71759 -0.102513 5.38241 -0.102513 5.79246 0.307538C6.20251 0.717588 6.20251 1.38241 5.79246 1.79246L3.53492 4.05Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoButton);
export default __webpack_public_path__ + "static/media/undo_button.db8666d4b68663163094073dd22d9474.svg";
export { ForwardRef as ReactComponent };